export enum Cookie {
	cookieConsent = 'cookieConsent',
	vehicleRecentSearches = 'vehiclesRecentSearches',
}
